import {differenceInDays, startOfDay} from 'date-fns';

import {isNil, max, min} from 'ramda';

import {parseDate} from 'shared/web';

import {PriceReportType} from '../types/PriceReportType';

export function getDaysOnStock(
  vehicle: {first_occurrence: string | null; last_occurrence: string | null},
  priceReport: PriceReportType
) {
  if (isNil(vehicle.first_occurrence) || isNil(vehicle.last_occurrence)) {
    return 0;
  }
  const firstOccurrenceDate = startOfDay(parseDate(vehicle.first_occurrence));
  const lastOccurrenceDate = startOfDay(parseDate(vehicle.last_occurrence));
  const reportCreationDate = startOfDay(parseDate(priceReport.created));
  const endDate = min(lastOccurrenceDate, reportCreationDate);
  const daysOnStock = differenceInDays(endDate, firstOccurrenceDate) + 1;
  return max(daysOnStock, 1);
}
